// Import Packages
import React from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import ArchiveSharpIcon from "@material-ui/icons/ArchiveSharp";
import HourglassEmptySharpIcon from '@material-ui/icons/HourglassEmptySharp';
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";
//import ZoomInIcon from "@material-ui/icons/ZoomIn";
//import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import Zoom from '@material-ui/core/Zoom';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

// Import Pages
import Info from "./Info";

// Import Icons
import UndoIcon from '../../../../../assets/icons/shortCutIcons/undo-icon.svg';
import RedoIcon from '../../../../../assets/icons/shortCutIcons/redo-icon.svg';
import ZoomInIcon from '../../../../../assets/icons/shortCutIcons/zoom-in-icon.svg';
import ZoomOutIcon from '../../../../../assets/icons/shortCutIcons/zoom-out-icon.svg';

import PasteIcon from '../../../../../assets/icons/shortCutIcons/paste-icon.svg'
import CutIcon from '../../../../../assets/icons/shortCutIcons/cut-icon.svg'
import CopyIcon from '../../../../../assets/icons/shortCutIcons/copy-icon.svg'
import DeleteIcon from '../../../../../assets/icons/shortCutIcons/delete-icon.svg'
import ImportIcon from '../../../../../assets/icons/shortCutIcons/import-icon.svg'
import ExportIcon from '../../../../../assets/icons/shortCutIcons/export-icon.svg'

const ShortCutSection = (props) => {
    const { t } = useTranslation();

    return (
        <div className="tabs">
            <ul>
                <Info value={t("CONTENT.FLOW.COPY")} placement="right">
                    <li onClick={() => props.onCopy()}>
                        <img src={CopyIcon} alt="" />
                    </li>
                </Info>
                <Info value={t("CONTENT.FLOW.CUT")} placement="right">
                    <li onClick={() => props.onCut()}>
                        <img src={CutIcon} alt="" />
                    </li>
                </Info>
                <Info value={t("CONTENT.FLOW.PASTE")} placement="right">
                    <li onClick={() => props.onPaste()}>
                        <img src={PasteIcon} alt="" />
                    </li>
                </Info>
                <Info value={t("CONTENT.FLOW.DELETE")} placement="right">
                    <li onClick={() => props.onDelete()}>
                        <img src={DeleteIcon} alt="" />
                    </li>
                </Info>
                <Info value={t("CONTENT.FLOW.IMPORT")} placement="right">
                    <li onClick={props.handleImport}>
                        <img src={ImportIcon} alt="" />
                    </li>
                </Info>
                <Info value={t("CONTENT.FLOW.EXPORT")} placement="right">
                    <li onClick={props.handleExport}>
                        <img src={ExportIcon} alt="" />
                    </li>
                </Info>
                {props.isDebugging && (
                    <Zoom in={props.isDebugging}>
                        <Info value={t("CONTENT.FLOW.SLOW-MOTION")} placement="right">
                            <li className="debug-icon" onClick={props.handleSlowMotion} style={{ backgroundColor: "rgb(215, 94, 94)" }}>
                                <HourglassEmptySharpIcon
                                    style={{ transform: "rotate(180deg)", fill: "white" }} />
                            </li>
                        </Info>
                    </Zoom>
                )}
                <div
                    className={`tabs-bottom-icons ${props.isDebugging
                        ? props.isDebuggingExpand
                            ? "tabs-bottom-icons-debug-expand"
                            : "tabs-bottom-icons-debug"
                        : ""
                        }`}
                >
                    <Info value={t("CONTENT.FLOW.REDO")} placement="top">
                        <li onClick={() => props.onForward()}>
                            <img src={RedoIcon} alt="" />
                        </li>
                    </Info>
                    <Info value={t("CONTENT.FLOW.UNDO")} placement="top">
                        <li onClick={() => props.onBack()}>
                            <img src={UndoIcon} alt="" />
                        </li>
                    </Info>

                    <Info value={t("CONTENT.FLOW.ZOOM-IN")} placement="top">
                        <li onClick={(e) => props.changeScale(e, "zoom-in")}>
                            <img src={ZoomInIcon} alt="" />
                        </li>
                    </Info>

                    <Info value={t("CONTENT.FLOW.ZOOM-OUT")} placement="top">
                        <li id="zoom-out" onClick={(e) => props.changeScale(e, "zoom-out")}>
                            <img src={ZoomOutIcon} alt="" />
                        </li>
                    </Info>

                </div>
            </ul>


        </div>

    );
};

export default ShortCutSection;
